<app-header></app-header>

<div class="site-content">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>
